<template>
    <div>
        <!--服务商信息 start-->
        <div class="content">
            <div class="txt1">{{ form.agent.name }}</div>
            <div class="txt1">{{ form.agent.agent_num }}</div>
        </div>
        <!--服务商 end-->
        <!--内容 start-->
        <div class="list" v-if="form.agent.agent_type == 0">
            <div class="list-item" v-for="(item, index) in list" :key="index" @click="jumpTo(item)">
                <div>{{ item.title }}</div>
                <van-icon name="arrow" />
            </div>
        </div>
        <div class="list" v-if="form.agent.agent_type == 1">
            <div class="list-item" v-for="(item, index) in list1" :key="index" @click="jumpTo(item)">
                <div>{{ item.title }}</div>
                <van-icon name="arrow" />
            </div>
        </div>
        <!--内容 end-->
        <!-- 退出登录按钮 start-->
        <div class="btn">
            <div class="btn-item" @click="logout">退出登录</div>
        </div>
        <!-- 退出登录按钮 end-->
    </div>
</template>

<script>
import { Dialog,Toast } from 'vant';
export default {
    name: "MyAgent", //我的
    data() {
        return {
            form: {},
            list: [
                { title: '基本信息', menu_url: '/AgentBasicinfomation' },
                { title: '修改密码', menu_url: '/AgentChangePassword' },
                { title: '我的分润', menu_url: '/MyAccount' },
                { title: '解除微信绑定', menu_url: '' }],
            list1: [
                { title: '基本信息', menu_url: '/AgentBasicinfomation' },
                { title: '修改密码', menu_url: '/AgentChangePassword' },
                { title: '解除微信绑定', menu_url: '' }]
        }
    },
    mounted() {
        this.theMerchants()
    },

    methods: {
        //服务商信息
        theMerchants() {
            this.$http.get('/wechat/api.agent.index/info').then(response => {
                this.form = response.data.msg
            })
        },
        //页面跳转
        jumpTo(item) {
            if (item.title == '解除微信绑定') {
                this.sign_wechat()
            } else {
                this.$router.push(item.menu_url)
            }
        },
        //退出登录
        logout() {
            var toast = Toast.loading({
                duration: 0,
                message: '正在退出',
                forbidClick: true,
                loadingType: 'spinner'
            })
            setTimeout(() => {
                // 跳转至登陆界面
                toast.clear()
                sessionStorage.clear()
                this.$router.push('/AgentImpower')
            }, 1000)
        },
        // 微信解绑
        sign_wechat() {
            Dialog.confirm({
                title: '温馨提示',
                message: '您确定要解除绑定吗？'
            }).then(() => {
                this.Logwechat()
            })
            .catch(() => {
                // on cancel
            })
        },

        Logwechat() {
            var toast = Toast.loading({
                duration: 0,
                message: '正在解绑',
                forbidClick: true,
                loadingType: 'spinner'
            })
            this.$http.delete('/wechat/api.agent.index/unBindAccount', {
                params: {
                    openid: window.localStorage.getItem('openid')
                }
            }).then(response => {
                // 跳转至登陆界面
                toast.clear()
                sessionStorage.clear()
                console.log('退出成功' + response.data)
                var toas = Toast.loading({
                    duration: 0,
                    message: '解绑成功',
                    forbidClick: true,
                    loadingType: 'spinner'
                })
                this.$router.push('/AgentImpower')
                setTimeout(function () {
                    toas.clear()
                }, 1000)
            })
        },
    },
}
</script>

<style scoped>
.content {
    width: 100%;
    height: 128px;
    background-color: rgba(20, 134, 251, 1);
    box-sizing: border-box;
    padding: 32px;
    font-weight: 700;
    font-size: 22px;
    color: #FFFFFF;

    .txt1 {
        line-height: 30px;
    }
}

.list {
    width: 100%;
    box-sizing: border-box;
    padding: 32px 16px;

    .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 45px;
        background-color: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        padding: 16px;
        border-bottom: 1px solid rgba(215, 215, 215, 1);
        font-weight: 300;
        font-size: 16px;
        color: #555555;
    }

    .list-item:first-child {
        border-radius: 12px 12px 0 0;
    }

    .list-item:last-child {
        border-bottom: none;
        border-radius: 0 0 12px 12px;
    }
}

.btn {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-item {
        width: 327px;
        height: 50px;
        line-height: 50px;
        background-color: rgba(20, 134, 251, 1);
        border-radius: 12px;
        color: #FFFFFF;
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
    }
}
</style>
